import { useContext, useMemo } from 'react';

// contexts
import { EditorContext } from '../../context/EditorContext';

// models
import {
    PushIntegrationModel,
    PushProviders,
} from '../../models/pushProvider.model';

// hooks
import usePushIntegrationsQuery from '../pushIntegrations/usePushIntegrationsQuery';

const INTEGRATIONS_WITH_LIMITS = [PushProviders.CleverTap];

export default function useIsProviderFrequencyLimitOverrideAllowed() {
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);
    const { data: pushIntegrations, isPending: isLoading } =
        usePushIntegrationsQuery();

    const pushProvider = useMemo<PushIntegrationModel | undefined>(() => {
        if (formulaType) {
            return pushIntegrations?.find((pushIntegration) =>
                pushIntegration.channels?.includes(formulaType),
            );
        }
    }, [formulaType, pushIntegrations]);

    const isFrequencyLimitAllowed = useMemo<boolean>(() => {
        return !!(
            pushProvider?.push_provider_name &&
            INTEGRATIONS_WITH_LIMITS.includes(pushProvider?.push_provider_name)
        );
    }, [pushProvider]);

    return { isLoading, isFrequencyLimitAllowed };
}
